import axios from 'axios';
import { GET_FORMULA_SOCIETE_DEFAULTS, ADD_OR_EDIT_FORMULA_SOCIETE_DEFAULT, DELETE_FORMULA_SOCIETE_DEFAULT, FORMULA_SOCIETE_DEFAULTS_LOADING, CLEAR_FORMULA_SOCIETE_DEFAULTS } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IFormula_societe_default } from '../../types/interfaces';
import store from '../store';

export const getFormula_societe_defaults = () => (dispatch: Function, getState: Function) => {
  dispatch({
    type: FORMULA_SOCIETE_DEFAULTS_LOADING
  });
  axios
    .get('/api/formulasocietedefaults', {...tokenConfig(getState)})
    .then(res =>
      dispatch({
        type: GET_FORMULA_SOCIETE_DEFAULTS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const addOrEditFormula_societe_default = (projectId: any, formulaId: number, userId: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/formulasocietedefaults', {projectId, formulaId, userId}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: ADD_OR_EDIT_FORMULA_SOCIETE_DEFAULT,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deleteFormula_societe_default = (id: number) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/formulasocietedefaults/${id}`, tokenConfig(getState))
    .then(res =>
      dispatch({
        type: DELETE_FORMULA_SOCIETE_DEFAULT,
        payload: id
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const setFormula_societe_defaultsLoading = () => {
  return {
    type: FORMULA_SOCIETE_DEFAULTS_LOADING
  };
};

export const clearFormula_societe_defaults = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_FORMULA_SOCIETE_DEFAULTS
  })
};